__turbopack_context__.v({
  "className": "space_grotesk_41265f96-module__cWjghG__className",
  "variable": "space_grotesk_41265f96-module__cWjghG__variable",
});
